class GTMEcommerce {

  static formVoucherTransactionPayload(transactionId, price, shipping_price) {
    return {
      'transactionId': transactionId,
      'transactionAffiliation': 'BirdieTime.com',
      'transactionTotal': price + shipping_price,
      'transactionShipping' : shipping_price,
      'transactionProducts': [
        {
          'sku': 1,
          'name': 'Gift Voucher',
          'category': 'voucher',
          'price': price,
          'quantity': 1,
        },
      ],
    };
  }

  static formEventTransactionPayload(order_number, { price_value },  { id, title, type }) {
    return {
      'transactionId': order_number,
      'transactionAffiliation': 'BirdieTime.com',
      'transactionTotal': price_value,
      'transactionProducts': [
        {
          'sku': id,
          'name': title,
          'category': type.join(', '),
          'price': price_value,
          'quantity': 1,
        },
      ],
    };
  }

  static formLessonTransactionPayload(order_number, { price_value },  { id, name }) {
    return {
      'transactionId': order_number,
      'transactionAffiliation': 'BirdieTime.com',
      'transactionTotal': price_value,
      'transactionProducts': [
        {
          'sku': id,
          'name': name,
          'category': 'lesson',
          'price': price_value,
          'quantity': 1,
        },
      ],
    };
  }

  static pageLoadGTMEcommerceTrack(transaction) {
    try {
      const storageAdapter = window.sessionStorage;
      if (storageAdapter) {
        storageAdapter.setItem('gtmEcommerceTrack', JSON.stringify(transaction));
      }
    }catch (e) {
      console.error(e);
    }
  }

  static asyncGTMEcommerceTrack(payload) {
    payload.event = 'BTPurchaseComplete';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
}

export { GTMEcommerce }


// WEBPACK FOOTER //
// ./src/utils/gtm-utils.js